import { escapeSpecificMarkdownCharacters } from "@edgetier/utilities";
import styles from "./chat.module.scss";
import { IWritingIssue } from "@edgetier/watchtower-types";
import classNames from "classnames";

export const formatWritingIssueMessage = (writingIssues: IWritingIssue[], message: string) => {
    // Split the message by character so we can use the writing issue start/end index to alter the string
    // without messing up the indexes of subsequent writing issues.
    const splitMessage = message.split("");
    // The Markdown component accepts a custom syntax: "**[someClassName]some text**" that allows class name(s)
    // to be added to that section of writing. This is used to highlight spelling and grammar issues.
    writingIssues.forEach(({ description, startIndex, endIndex, writingIssueType }) => {
        // If starting index from backend is a space, we should move one over.
        const startIsEmpty = splitMessage[startIndex] === " ";

        const newStartIndex = startIsEmpty ? startIndex + 1 : startIndex;
        splitMessage[newStartIndex] =
            `**issueStart[${styles[`writing-issue-${writingIssueType.toLowerCase()}`]} writing-issue writing-issue--${writingIssueType.toLowerCase()},${description}]${splitMessage[newStartIndex]}`;

        // Avoid using an index higher than message character array
        const newEndIndex = startIsEmpty ? endIndex + 1 : endIndex;
        const writingIssueEndIndex = Math.min(newEndIndex, splitMessage.length - 1);

        splitMessage[writingIssueEndIndex] = `${splitMessage[writingIssueEndIndex]}issueEnd**`;
    });
    return escapeSpecificMarkdownCharacters(splitMessage.join(""), ["`"]);
};

export const formatClassNamesMessage = (
    sentenceToHighlight: string[],
    message: string,
    options?: { clearPrevious?: boolean; className?: string; additionalClassName?: string | string[] }
) => {
    // The Markdown component accepts a custom syntax: "**[someClassName]some text**" that allows class name(s)
    // to be added to that section of writing. This is used to highlight spelling and grammar issues.
    let messageBuffer = message;
    // Remove all previous highlights
    if (options?.clearPrevious) {
        const previousHighlightsMatches = message.matchAll(/\*\*classNameStart\[(.*),(.*)\]([\s\S]*)classNameEnd\*\*/g);
        previousHighlightsMatches.forEach((match) => {
            messageBuffer = messageBuffer.replace(match[0], match[3]);
        });
    }
    sentenceToHighlight.forEach((sentence) => {
        messageBuffer = messageBuffer.replaceAll(
            sentence,
            `**classNameStart[${classNames(options?.className || "highlight", options?.additionalClassName)},]${sentence}classNameEnd**`
        );
    });
    return escapeSpecificMarkdownCharacters(messageBuffer, ["`"]);
};
